import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/button';
import { CircleCheck } from '../../assets/icons';

const ResetSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className="auth-container">
            <div className="reset-success">
                <img src={CircleCheck} alt="Success" className="success-icon" />
                <h1>Password Reset Successful!</h1>
                <p>Your password has been successfully reset. You can now login with your new password.</p>
                <Button 
                    text="Login" 
                    onClick={() => navigate('/login')}
                    fullWidth
                />
            </div>
        </div>
    );
};

export default ResetSuccess;